var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 3.99999H14.6667V2.66666H2.66667C1.93333 2.66666 1.33333 3.26666 1.33333 3.99999V11.3333H0V13.3333H9.33333V11.3333H2.66667V3.99999ZM15.3333 5.33332H11.3333C10.9667 5.33332 10.6667 5.63332 10.6667 5.99999V12.6667C10.6667 13.0333 10.9667 13.3333 11.3333 13.3333H15.3333C15.7 13.3333 16 13.0333 16 12.6667V5.99999C16 5.63332 15.7 5.33332 15.3333 5.33332ZM14.6667 11.3333H12V6.66666H14.6667V11.3333Z",
    fill: "#A8ADB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/device.90941429210ce74a35bf7d81857a18cd.svg";
export { ForwardRef as ReactComponent };